import script from "./AutomatedIncomeVerificationConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomatedIncomeVerificationConsent.vue?vue&type=script&setup=true&lang=ts"

import "./AutomatedIncomeVerificationConsent.vue?vue&type=style&index=0&id=07b956f0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b956f0"]])

export default __exports__